import { render, staticRenderFns } from "./person.vue?vue&type=template&id=39e8c68c&scoped=true&"
import script from "./person.vue?vue&type=script&lang=ts&"
export * from "./person.vue?vue&type=script&lang=ts&"
import style0 from "./person.vue?vue&type=style&index=0&id=39e8c68c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8c68c",
  null
  
)

export default component.exports